import { IForm } from './iform';
export interface ICadastro {
    Indice: number;
    CampoIdentificador: IForm;
    LstItensCadastro: IForm[];
}
